parcelRequire.extendImportMap({"kPsoI":"web-vitals.2dff70bb.js"});